// extracted by mini-css-extract-plugin
export default {"zoomControls":"Daa-z","zoomControlButton":"Eaa-z","zoomBanner":"Faa-z","bannerButton":"Gaa-z","imageButton":"Haa-z","zoom":"Iaa-z","zoomContent":"Jaa-z"};